import { useQuery } from '@tanstack/react-query';
import { getPermissions } from '../api/ROLES/roles';

export const useGetPermissions = () => {
    return useQuery({
        queryKey: ['permissions'],
        queryFn: getPermissions,
        staleTime: 5 * 60 * 1000,
    });
};
